export default __webpack_public_path__ + "static/media/sp.69ee2808.png";